import React from "react";
import CustomTooltip from "./CustomTooltip";
import { isString } from "app/_helpers/helper";

export const OverFlowTip = ({ children }) => {
  return (
    <>
      {isString(children) && children.length > 15 ? (
        <CustomTooltip tooltip={children}>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "105px",
            }}
          >
            {children}
          </div>
        </CustomTooltip>
      ) : (
        <div>{children}</div>
      )}
    </>
  );
};

export default OverFlowTip;
